"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentMetadata = void 0;
const tslib_1 = require("tslib");
const function_1 = require("@prismicio/types-internal/lib/validators/function");
const t = tslib_1.__importStar(require("io-ts"));
const codec = t.exact(t.intersection([
    t.type({
        title: t.string,
        description: t.string,
    }),
    t.partial({
        imageURL: (0, function_1.nullable)(t.string),
    }),
]));
exports.DocumentMetadata = {
    empty: {
        title: "Untitled document",
        description: "",
        imageURL: undefined,
    },
    codec,
};
